// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu-tabs-auth_menu-tabs__H96Xr {
    display: flex;
    flex-direction: row;
    gap: 0;
    background-color: var(--color-content-sidebar);
    padding: 3px;
    border-radius: 5px;
    width: 100%;
}

.menu-tabs-auth_tab-item__We4gn {
    flex-grow: 1;
    font-size: 14px;
    font-weight: 450;
    border: none;
    background: transparent;
    padding: 5px 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 4px;
    width: -moz-fit-content;
    width: fit-content;
    white-space: nowrap;
    color: var(--color-input-wrapper);
}

.menu-tabs-auth_tab-item-active__9h8ej {
    color: var(--color-secondary-typography);
    background-color: var(--color-content);
    border-radius: 5px;
}

@media screen and (max-width: 1000px) {
    .menu-tabs-auth_menu-tabs__H96Xr {
        width: 100%;
        overflow: scroll;
        -ms-overflow-style: none;  /* Internet Explorer 10+ */
        scrollbar-width: none;  /* Firefox */
    }

    .menu-tabs-auth_menu-tabs__H96Xr::-webkit-scrollbar  {
        display: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/menu-tabs-auth/menu-tabs-auth.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,MAAM;IACN,8CAA8C;IAC9C,YAAY;IACZ,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;IACvB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,uBAAkB;IAAlB,kBAAkB;IAClB,mBAAmB;IACnB,iCAAiC;AACrC;;AAEA;IACI,wCAAwC;IACxC,sCAAsC;IACtC,kBAAkB;AACtB;;AAEA;IACI;QACI,WAAW;QACX,gBAAgB;QAChB,wBAAwB,GAAG,0BAA0B;QACrD,qBAAqB,GAAG,YAAY;IACxC;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".menu-tabs {\n    display: flex;\n    flex-direction: row;\n    gap: 0;\n    background-color: var(--color-content-sidebar);\n    padding: 3px;\n    border-radius: 5px;\n    width: 100%;\n}\n\n.tab-item {\n    flex-grow: 1;\n    font-size: 14px;\n    font-weight: 450;\n    border: none;\n    background: transparent;\n    padding: 5px 10px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    gap: 4px;\n    width: fit-content;\n    white-space: nowrap;\n    color: var(--color-input-wrapper);\n}\n\n.tab-item-active {\n    color: var(--color-secondary-typography);\n    background-color: var(--color-content);\n    border-radius: 5px;\n}\n\n@media screen and (max-width: 1000px) {\n    .menu-tabs {\n        width: 100%;\n        overflow: scroll;\n        -ms-overflow-style: none;  /* Internet Explorer 10+ */\n        scrollbar-width: none;  /* Firefox */\n    }\n\n    .menu-tabs::-webkit-scrollbar  {\n        display: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menu-tabs": `menu-tabs-auth_menu-tabs__H96Xr`,
	"tab-item": `menu-tabs-auth_tab-item__We4gn`,
	"tab-item-active": `menu-tabs-auth_tab-item-active__9h8ej`
};
export default ___CSS_LOADER_EXPORT___;
